"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatePlanType = void 0;
var RatePlanType;
(function (RatePlanType) {
    RatePlanType["BRONZE"] = "BRONZE";
    RatePlanType["SILVER"] = "SILVER";
    RatePlanType["GOLD"] = "GOLD";
})(RatePlanType || (exports.RatePlanType = RatePlanType = {}));
//# sourceMappingURL=rate-plan.js.map